import { createFileRoute } from '@tanstack/react-router'
import SigningSettings from '@/pages/settings/signing'

export const Route = createFileRoute(
  '/(protected)/settings/signing'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <SigningSettings />
}
